import { EmspUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/emsp-users/emsp-user.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface EmspBoEmspUserListEmailAddressHeaderProps
  extends HeaderContext<EmspUserModel, EmspUserModel['emailAddress']> {}

export const EmspBoEmspUserListEmailAddressHeader =
  (): // props: EmspBoEmspUserListEmailAddressHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-emsp-user.email-address');
  };
